import { render, staticRenderFns } from "./ConfirmationRequestParsingSettings.vue?vue&type=template&id=22254266"
import script from "./ConfirmationRequestParsingSettings.vue?vue&type=script&lang=js"
export * from "./ConfirmationRequestParsingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports